import { State, TableBlock } from "../../types";

export type NextActiveBlockAction = Readonly<{
  reverse: boolean;
  type: "NEXT ACTIVE BLOCK";
}>;

export const nextActiveBlock = (state: State, action: NextActiveBlockAction): State => {
  // TODO : When within a table block, it's probably better to navigate to the next
  // cell rather than to the next block

  var blockIndex = state.activeBlockOrder.findIndex(x => x === state.selectedBlockId);
  var newIndex = blockIndex;
  var newCellId = state.selectedCellId;
  if (!action.reverse) {
    newIndex = Math.min(blockIndex + 1, state.activeBlockOrder.length - 1)
  } else {
    newIndex = Math.max(blockIndex -1, 0);
  }
  var newId = state.activeBlockOrder[newIndex];
  var block = <TableBlock> state.blocks[newId];
  state.selectedCellId
  if (block.cells && block.cells.length > 0) {
    newCellId = block.cells[0][0].id;
  }

  return {
    ...state,
    scrollToPageBlock: newId,
    selectedBlockId: newId,
    selectedCellId: newCellId
  };
};
